(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2046,648,4346,682],{

/***/ 4346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/components/shared/breadCrumb/styles/styles.module.scss
var styles_module = __webpack_require__(6962);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/breadCrumb.avif
/* harmony default export */ var breadCrumb = ({"src":"/_next/static/media/breadCrumb.aff9d432.avif","height":1330,"width":2000,"blurDataURL":"data:image/avif;base64,AAAAHGZ0eXBhdmlmAAAAAG1pZjFhdmlmbWlhZgAAAXBtZXRhAAAAAAAAACFoZGxyAAAAAAAAAABwaWN0AAAAAAAAAAAAAAAAAAAAAA5waXRtAAAAAAABAAAANGlsb2MAAAAAREAAAgABAAAAAAGUAAEAAAAAAAAATwACAAAAAAHjAAEAAAAAAAAAFQAAADhpaW5mAAAAAAACAAAAFWluZmUCAAAAAAEAAGF2MDEAAAAAFWluZmUCAAAAAAIAAGF2MDEAAAAAr2lwcnAAAACKaXBjbwAAAAxhdjFDgSACAAAAABRpc3BlAAAAAAAAAAgAAAAFAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAcAAAAAA5waXhpAAAAAAEIAAAAOGF1eEMAAAAAdXJuOm1wZWc6bXBlZ0I6Y2ljcDpzeXN0ZW1zOmF1eGlsaWFyeTphbHBoYQAAAAAdaXBtYQAAAAAAAAACAAEDgQIDAAIEhAIFhgAAABppcmVmAAAAAAAAAA5hdXhsAAIAAQABAAAAbG1kYXQSAAoIOAi8YQENBpAyQRTAAABQqEVlZka/Msh/reC4VnUKNzTWMxH5mLGkhcrFORQnQ2II1O05fqzWbykXkMdGLA/rXmxorUD2MsXhlSGAEgAKBRgIvGFQMgoUwAABAAF1UKUo","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/works_breadcrumb.jpg
/* harmony default export */ var works_breadcrumb = ({"src":"/_next/static/media/works_breadcrumb.537d82bb.jpg","height":200,"width":1700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAYEAEAAwEAAAAAAAAAAAAAAAAAAQIzcf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAIxAf/aAAwDAQACEQMRAD8AhYwtwA7UnWYf/9k=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/servics_breadcrumb.jpg
/* harmony default export */ var servics_breadcrumb = ({"src":"/_next/static/media/servics_breadcrumb.406428d8.jpg","height":200,"width":1700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAZEAEAAgMAAAAAAAAAAAAAAAAAAgMzcsL/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AIivNHToAkHX/9k=","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/Index.js












var BreadCrumb = function BreadCrumb(_ref) {
  var title = _ref.title;
  var router = (0,next_router.useRouter)();
  var locale = router.locale;
  var isRtl = locale === "ar";
  var isServicesPage = router.pathname === "/services";
  var isWorksPage = router.pathname === "/ourworks" || router.pathname === "/blogs" || router.pathname === "/blogs/[slug]";
  var backgroundImage = isServicesPage ? servics_breadcrumb : isWorksPage ? works_breadcrumb : breadCrumb;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (styles_module_default()).breads,
    dir: locale === "ar" ? "rtl" : "ltr",
    style: {
      backgroundImage: "url(".concat(backgroundImage.src || backgroundImage, ")")
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).breads__inner,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (styles_module_default()).breads__content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/contactus",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (styles_module_default())["cta-button-red"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "contact-us"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["icon-circle"],
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  style: {
                    transform: isRtl ? "none" : "scaleX(-1)"
                  },
                  width: "18",
                  height: "18",
                  viewBox: "0 0 18 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53577 3.53556L14.1424 14.1422",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  })]
                })
              })]
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var Index = (BreadCrumb);

/***/ }),

/***/ 38:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f8": function() { return /* binding */ buildApiUrl; }
/* harmony export */ });
/* unused harmony exports getImageUrl, validateImageUrl, getImageDimensions */
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


var buildApiUrl = function buildApiUrl(path) {
  if (!path) return "";

  try {
    new URL(path);
    return path;
  } catch (_unused) {
    var base = "https://mu7.ejjadh.info" || 0;
    var sep = path.startsWith("/") ? "" : "/";
    return "".concat(base).concat(sep).concat(path);
  }
}; // Helper function to ensure valid image URLs and proper error handling

var getImageUrl = function getImageUrl(path) {
  if (!path) return null;

  try {
    // If it's already a full URL, return it
    new URL(path);
    return path;
  } catch (_unused2) {
    // If it's a relative path, prepend the API URL
    return buildApiUrl(path);
  }
}; // Helper function to validate image

var validateImageUrl = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url, {
              method: "HEAD"
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.ok);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function validateImageUrl(_x) {
    return _ref.apply(this, arguments);
  };
}())); // Helper function to get proper image dimensions

var getImageDimensions = function getImageDimensions() {
  var imageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  var dimensions = {
    "default": {
      width: 800,
      height: 600
    },
    thumbnail: {
      width: 150,
      height: 150
    },
    banner: {
      width: 1920,
      height: 1080
    },
    profile: {
      width: 300,
      height: 300
    }
  };
  return dimensions[imageType] || dimensions["default"];
};

/***/ }),

/***/ 2046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AboutPage_AboutPage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./src/assets/images/Vector1.png
/* harmony default export */ var Vector1 = ({"src":"/_next/static/media/Vector1.24110ef7.png","height":28,"width":92,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAACVBMVEX///////////+OSuX+AAAAA3RSTlMQAmp5AY1qAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVR4nGNgBAMGJgYoYAQAAH4ACtuzXEMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/assets/images/Vector2.png
/* harmony default export */ var Vector2 = ({"src":"/_next/static/media/Vector2.fb5f6699.png","height":28,"width":92,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEX///9MaXH///////+1it7yAAAABHRSTlMMABNrQsogYAAAAAlwSFlzAAALEwAACxMBAJqcGAAAABZJREFUeJxjYGJgYGBgYmJgYAQDJmYAAIoAEj6CvyMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./src/helpers/imageHelpers.js
var imageHelpers = __webpack_require__(38);
// EXTERNAL MODULE: ./src/modules/AboutPage/AboutPage.module.scss
var AboutPage_module = __webpack_require__(1973);
var AboutPage_module_default = /*#__PURE__*/__webpack_require__.n(AboutPage_module);
// EXTERNAL MODULE: ./src/components/shared/breadCrumb/Index.js + 3 modules
var Index = __webpack_require__(4346);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/modules/AboutPage/AboutPage.jsx









var PageHeader = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(9477), __webpack_require__.e(4208), __webpack_require__.e(8670)]).then(__webpack_require__.bind(__webpack_require__, 2094));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2094)];
    }
  }
});
var AboutParallelogram = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5677).then(__webpack_require__.bind(__webpack_require__, 5677));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(5677)];
    }
  }
});
var Spliter = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1185).then(__webpack_require__.bind(__webpack_require__, 9245));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9245)];
    }
  }
});
var CommonQuestions = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1868).then(__webpack_require__.bind(__webpack_require__, 1868));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1868)];
    }
  }
});
var Footer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(7148), __webpack_require__.e(6515)]).then(__webpack_require__.bind(__webpack_require__, 7148));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7148)];
    }
  }
});






var AboutPage = function AboutPage(_ref) {
  var _about_us$, _about_us$$categories, _about_us$$categories2, _about_us$$categories3, _about_us$$categories4, _advantages$, _advantages$$categori, _advantages$$categori2, _statistics$, _statistics$$categori, _statistics$$categori2, _questions$, _questions$$categorie, _questions$$categorie2, _information$, _information$$categor, _information$$categor2, _information$$categor3, _statisticsSection$da, _targetQuestion$data, _data$about_us, _aboutUsData$descript, _informationData$firs, _informationData$firs2, _informationData$seco, _informationData$seco2;

  var data = _ref.data;
  var statistics = data.statistics,
      questions = data.questions,
      advantages = data.advantages,
      about_us = data.about_us,
      information = data.information;
  var aboutUsData = about_us === null || about_us === void 0 ? void 0 : (_about_us$ = about_us[0]) === null || _about_us$ === void 0 ? void 0 : (_about_us$$categories = _about_us$.categories) === null || _about_us$$categories === void 0 ? void 0 : (_about_us$$categories2 = _about_us$$categories[0]) === null || _about_us$$categories2 === void 0 ? void 0 : (_about_us$$categories3 = _about_us$$categories2.posts) === null || _about_us$$categories3 === void 0 ? void 0 : (_about_us$$categories4 = _about_us$$categories3[0]) === null || _about_us$$categories4 === void 0 ? void 0 : _about_us$$categories4.data;
  var advantagesData = advantages === null || advantages === void 0 ? void 0 : (_advantages$ = advantages[0]) === null || _advantages$ === void 0 ? void 0 : (_advantages$$categori = _advantages$.categories) === null || _advantages$$categori === void 0 ? void 0 : (_advantages$$categori2 = _advantages$$categori[0]) === null || _advantages$$categori2 === void 0 ? void 0 : _advantages$$categori2.posts;
  var statisticsData = statistics === null || statistics === void 0 ? void 0 : (_statistics$ = statistics[0]) === null || _statistics$ === void 0 ? void 0 : (_statistics$$categori = _statistics$.categories) === null || _statistics$$categori === void 0 ? void 0 : (_statistics$$categori2 = _statistics$$categori[0]) === null || _statistics$$categori2 === void 0 ? void 0 : _statistics$$categori2.posts;
  var questionsData = questions === null || questions === void 0 ? void 0 : (_questions$ = questions[0]) === null || _questions$ === void 0 ? void 0 : (_questions$$categorie = _questions$.categories) === null || _questions$$categorie === void 0 ? void 0 : (_questions$$categorie2 = _questions$$categorie[0]) === null || _questions$$categorie2 === void 0 ? void 0 : _questions$$categorie2.posts;
  var informationData = information === null || information === void 0 ? void 0 : (_information$ = information[0]) === null || _information$ === void 0 ? void 0 : (_information$$categor = _information$.categories) === null || _information$$categor === void 0 ? void 0 : (_information$$categor2 = _information$$categor[0]) === null || _information$$categor2 === void 0 ? void 0 : (_information$$categor3 = _information$$categor2.posts) === null || _information$$categor3 === void 0 ? void 0 : _information$$categor3[0].data; // =========================================================

  var statisticsSection = statisticsData === null || statisticsData === void 0 ? void 0 : statisticsData.find(function (question) {
    return question.id === 417;
  });
  var statisticsSectionBackgroundImage = statisticsSection === null || statisticsSection === void 0 ? void 0 : (_statisticsSection$da = statisticsSection.data) === null || _statisticsSection$da === void 0 ? void 0 : _statisticsSection$da.image;
  var filteredStatistics = statisticsData === null || statisticsData === void 0 ? void 0 : statisticsData.filter(function (question) {
    return question.id !== 417;
  }); // =========================================================

  var targetQuestion = questionsData === null || questionsData === void 0 ? void 0 : questionsData.find(function (question) {
    return question.id === 415;
  });
  var commonQuestionsBackgroundImage = targetQuestion === null || targetQuestion === void 0 ? void 0 : (_targetQuestion$data = targetQuestion.data) === null || _targetQuestion$data === void 0 ? void 0 : _targetQuestion$data.image;
  var filteredQuestions = questionsData === null || questionsData === void 0 ? void 0 : questionsData.filter(function (question) {
    return question.id !== 415;
  }); // =========================================================

  var router = (0,next_router.useRouter)();
  var lang = router.locale;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Index["default"], {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "about"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (AboutPage_module_default())["about-section"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: (data === null || data === void 0 ? void 0 : (_data$about_us = data.about_us) === null || _data$about_us === void 0 ? void 0 : _data$about_us.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(AboutParallelogram, {
          backgroundPath: "".concat(aboutUsData !== null && aboutUsData !== void 0 && aboutUsData.image ? "https://mu7.ejjadh.info" + (aboutUsData === null || aboutUsData === void 0 ? void 0 : aboutUsData.image) : ""),
          withButton: false,
          primaryText: aboutUsData === null || aboutUsData === void 0 ? void 0 : aboutUsData.title[lang],
          secondaryText: aboutUsData === null || aboutUsData === void 0 ? void 0 : (_aboutUsData$descript = aboutUsData.description) === null || _aboutUsData$descript === void 0 ? void 0 : _aboutUsData$descript[lang],
          imageMeta: aboutUsData === null || aboutUsData === void 0 ? void 0 : aboutUsData.imageMeta,
          onClickButtonFunction: function onClickButtonFunction() {
            return router.push("/ourworks");
          }
        })
      }), (advantagesData === null || advantagesData === void 0 ? void 0 : advantagesData.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (AboutPage_module_default())["advantages-section"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container["default"], {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (AboutPage_module_default())["advantages-header"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "why-choose"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "MU7"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((AboutPage_module_default())["advantages-timeline"], " ").concat(lang === "ar" ? (AboutPage_module_default()).rtl : ""),
            dir: lang === "ar" ? "rtl" : "ltr",
            children: advantagesData === null || advantagesData === void 0 ? void 0 : advantagesData.map(function (post, index) {
              var _post$data, _post$data2, _post$data2$title, _post$data3, _post$data3$title, _post$data4, _post$data4$descripti;

              var arrowImage = index % 2 === 0 ? Vector1 : Vector2;
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (AboutPage_module_default())["advantage-item"],
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (AboutPage_module_default())["advantage-icon"],
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: (0,imageHelpers/* buildApiUrl */.f8)(post === null || post === void 0 ? void 0 : (_post$data = post.data) === null || _post$data === void 0 ? void 0 : _post$data.image),
                      alt: (post === null || post === void 0 ? void 0 : (_post$data2 = post.data) === null || _post$data2 === void 0 ? void 0 : (_post$data2$title = _post$data2.title) === null || _post$data2$title === void 0 ? void 0 : _post$data2$title[lang]) || "advantage-icon",
                      width: 58,
                      height: 58,
                      priority: index < 2
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: post === null || post === void 0 ? void 0 : (_post$data3 = post.data) === null || _post$data3 === void 0 ? void 0 : (_post$data3$title = _post$data3.title) === null || _post$data3$title === void 0 ? void 0 : _post$data3$title[lang]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: post === null || post === void 0 ? void 0 : (_post$data4 = post.data) === null || _post$data4 === void 0 ? void 0 : (_post$data4$descripti = _post$data4.description) === null || _post$data4$descripti === void 0 ? void 0 : _post$data4$descripti[lang]
                  })]
                }), index < advantagesData.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (AboutPage_module_default())["advantage-arrow"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: arrowImage,
                    alt: "timeline-arrow",
                    width: 82,
                    height: 24
                  })
                })]
              }, (post === null || post === void 0 ? void 0 : post.id) || index);
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spliter, {
        primaryTitle: informationData === null || informationData === void 0 ? void 0 : (_informationData$firs = informationData.firstTitle) === null || _informationData$firs === void 0 ? void 0 : _informationData$firs[lang],
        primaryHtml: informationData === null || informationData === void 0 ? void 0 : (_informationData$firs2 = informationData.firstDescription) === null || _informationData$firs2 === void 0 ? void 0 : _informationData$firs2[lang],
        secondaryTitle: informationData === null || informationData === void 0 ? void 0 : (_informationData$seco = informationData.secondTitle) === null || _informationData$seco === void 0 ? void 0 : _informationData$seco[lang],
        secondaryHtml: informationData === null || informationData === void 0 ? void 0 : (_informationData$seco2 = informationData.secondDescription) === null || _informationData$seco2 === void 0 ? void 0 : _informationData$seco2[lang]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (AboutPage_module_default())["statistics-section"],
      style: {
        backgroundImage: statisticsSectionBackgroundImage ? "url(".concat((0,imageHelpers/* buildApiUrl */.f8)(statisticsSectionBackgroundImage), ")") : ""
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (AboutPage_module_default())["statistics-overlay"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container["default"], {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((AboutPage_module_default())["statistics-list"], " ").concat(lang === "ar" ? (AboutPage_module_default()).rtl : ""),
            dir: lang === "ar" ? "rtl" : "ltr",
            children: filteredStatistics === null || filteredStatistics === void 0 ? void 0 : filteredStatistics.map(function (post, index) {
              var _post$data5, _post$data5$title, _post$data6, _post$data6$descripti;

              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (AboutPage_module_default())["statistic-card"],
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (AboutPage_module_default())["statistic-circle"],
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: post === null || post === void 0 ? void 0 : (_post$data5 = post.data) === null || _post$data5 === void 0 ? void 0 : (_post$data5$title = _post$data5.title) === null || _post$data5$title === void 0 ? void 0 : _post$data5$title[lang]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: post === null || post === void 0 ? void 0 : (_post$data6 = post.data) === null || _post$data6 === void 0 ? void 0 : (_post$data6$descripti = _post$data6.description) === null || _post$data6$descripti === void 0 ? void 0 : _post$data6$descripti[lang]
                  })]
                })
              }, (post === null || post === void 0 ? void 0 : post.id) || index);
            })
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CommonQuestions, {
      commonQuestionsBackgroundImage: commonQuestionsBackgroundImage,
      filteredQuestions: filteredQuestions
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
};

/* harmony default export */ var AboutPage_AboutPage = (AboutPage);

/***/ }),

/***/ 6962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breads":"styles_breads__eY1Zd","breads__inner":"styles_breads__inner__WYN36","breads__content":"styles_breads__content__i7wfq","cta-button-red":"styles_cta-button-red__Oa5fB","icon-circle":"styles_icon-circle__VDLuX"};

/***/ }),

/***/ 1973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"about-section":"AboutPage_about-section__0ROQt","wrapper-content":"AboutPage_wrapper-content__36MCo","about-second-content":"AboutPage_about-second-content__nH3rc","about-first-content":"AboutPage_about-first-content__BGdFK","text":"AboutPage_text__JS6bq","center-text":"AboutPage_center-text__U3yZ6","advantages-timeline":"AboutPage_advantages-timeline__4Fcip","advantage-item":"AboutPage_advantage-item__GWEOR","advantage-arrow":"AboutPage_advantage-arrow__e79oY","advantages-section":"AboutPage_advantages-section__4bNLi","advantages-header":"AboutPage_advantages-header__cGWuu","rtl":"AboutPage_rtl__PK_IV","advantage-icon":"AboutPage_advantage-icon__pN5TZ","statistics-section":"AboutPage_statistics-section__1Ttyj","statistics-overlay":"AboutPage_statistics-overlay__qOg3x","statistics-list":"AboutPage_statistics-list___B6jQ","statistic-card":"AboutPage_statistic-card__aTG0x","statistic-circle":"AboutPage_statistic-circle__8b3LR","customSswiper":"AboutPage_customSswiper__Tvako","questions":"AboutPage_questions__P_dzS","flex":"AboutPage_flex__6lKeH","shapes":"AboutPage_shapes__EwSEk","background-image":"AboutPage_background-image__m0nPb","overlay-text":"AboutPage_overlay-text__iI6vf","BlueHoleIcon":"AboutPage_BlueHoleIcon__VtI49","customHead":"AboutPage_customHead__nAdaC"};

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["default"] = (Container);

/***/ }),

/***/ 4012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 6896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ })

}]);